import { ProgressUpdate } from '../types/appShowcase';

export const resumeUpdates: ProgressUpdate[] = [
  {
    date: 'Aug 31, 2026',
    title: 'MCP Platform + grocery-mcp + gmail-mcp',
    detail:
      'Added three AI apps to the catalog: shared MCP ECS Fargate platform, grocery-mcp (Kroger tools), and gmail-mcp (Gmail tools), each with showcase pages and live ALB links. Added github-mcp as Planned for GitHub Project board tools.',
  },
  {
    date: 'Aug 20, 2026',
    title: 'CareerPilot AI + KubeSentry portfolio updates',
    detail:
      'Added CareerPilot AI to the app catalog and showcase (live app link). Updated KubeSentry AI summary, roadmap, and progress for graph-based agents, MCP tools, S3 alert persistence, and PendingTooLong detection.',
  },
  {
    date: 'Jul 6, 2026',
    title: 'Resume PDF update + interactive hotspots',
    detail:
      'Updated the resume PDF with current projects and experience, including KubeSentry AI, the Internal Innovation Initiative, and recent client work. On the interactive resume, added a clickable KubeSentry AI hotspot with a full project description and GitHub link. Fixed overlapping click boxes so the Internal Innovation area no longer covers the AI & Cloud Projects heading.',
  },
  {
    date: 'Jun 2026',
    title: 'Interactive resume',
    detail:
      'Added clickable hotspots on the PDF with detail modals for roles, projects, and certifications.',
  },
  {
    date: 'Jun 2026',
    title: 'Portfolio site refresh',
    detail:
      'Redesigned Black Cloud with project showcase pages, app routing, and GitHub Actions deploys.',
  },
  {
    date: 'Jun 2026',
    title: 'Mayo Clinic engagement',
    detail:
      'Enhanced Safety Platform with React, GCP, Azure auth integration, and CI/CD improvements.',
  },
  {
    date: '2025',
    title: 'Capital One',
    detail:
      'Led zero-downtime Aurora PostgreSQL migration to Terraform and improved Go test coverage.',
  },
  {
    date: '2024',
    title: 'RAG proof of concept',
    detail:
      'Built a RAG application with AWS Bedrock, Titan Embeddings, and ChromaDB for semantic search.',
  },
];
